import textFit from "textfit";
import throttle from "lodash.throttle";
import gsap from "gsap/all";

export default () => ({
  init() {
    window.addEventListener(
      "resize",
      throttle(() => {
        this.setTextSize();
      }, 200)
    );

    this.setTextSize();

    setTimeout(() => {
      this.setTextSize();
    }, 300);

    this.initAnimation();
  },

  setTextSize() {
    textFit(document.querySelectorAll(".quote blockquote"));
  },

  initAnimation() {
    const inBackend = document.body.classList.contains("neos-backend");

    if (inBackend) return;

    const quotes = document.querySelectorAll(".quote");

    quotes.forEach((quote) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: quote,
          start: "top 85%",
        },
      });

      tl.to(quote.querySelector(".quote-container"), {
        opacity: 1,
        delay: 0.5,
        duration: 1,
      }).to(
        quote.querySelectorAll(".curve"),
        {
          x: 0,
          opacity: 1,
        },
        "-=0.4"
      );
    });
  },
});
